<template>
  <div class="main_right di-ding hbl-class center" style="position: relative">
    <breadcrumb :breadcrumb="subConfig.breadcrumb"/>
    <div :class="{ flexBox: subConfig.searchTree }">
      <div class="school" v-show="subConfig.searchTree && subConfig.searchTree.searchType === 'code'" :class="{ borderRight: subConfig.searchTree, paddingTop: subConfig.searchTree}">
        <el-input placeholder="名称" v-model="filterText" size="small"
                  class="margin-bottom-4" />
        <device-tree class="filter-tree"
                     :filterKey="filterText" :update="treeUpdate1"
                     @selected="handleSelected"/>
      </div>
      <div class="school" v-show="subConfig.searchTree && subConfig.searchTree.searchType === 'face'" :class="{ borderRight: subConfig.searchTree, paddingTop: subConfig.searchTree}">
        <el-input placeholder="名称" v-model="filterText" size="small"
                  class="margin-bottom-4" />
        <device-tree class="filter-tree"
                     :filterKey="filterText" :update="treeUpdate2"
                     @selected="handleSelected"/>
      </div>
      <div class="school" v-show="subConfig.searchTree && subConfig.searchTree.searchType !== 'code' && subConfig.searchTree.searchType !== 'face'" :class="{ borderRight: subConfig.searchTree, paddingTop: subConfig.searchTree}">
        <el-input placeholder="名称" v-model="filterText" size="small"
                  class="margin-bottom-4" />
        <device-tree class="filter-tree"
                     :filterKey="filterText" :update="treeUpdate"
                     @selected="handleSelected"/>
      </div>
      <div :class="{ w77: subConfig.searchTree, mr: subConfig.searchTree, paddingTop: subConfig.searchTree }" >

        <!-- region 顶部操作栏 -->
        <div class="op-bar" :class="{hasMargin: !subConfig.searchTree}">
          <div class="line" :class="{ block: subConfig.searchTree }" v-for="line in subConfig.opBar" style="padding:0">
            <op-bar-items v-for="(flexItem, index) in line"
                          :data="data.length > 0 && data[0]"
                          :items="flexItem" :key="diName + index"
                          :requestBody="requestBody"
                          @search="search" 
                           />
          </div>
        </div>
        <!-- endregion 顶部操作栏 -->
        <!-- region 表格 -->
        <el-table v-loading="loading" :data="data" :height="618"
                  class="table" header-row-class-name="di-ding-table-header"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column v-if="subConfig.table.selectBox" type="selection"
                           width="55" />

          <el-table-column :label="label" :prop="key" :key="key"
                           :min-width="minWidth"
                           :width="width"
                           v-for="([key, {type, label, renderContent, minWidth, width}], tableIndex) in this.keyMappingEntitiesForUi"
          >
            <template slot-scope="scope">
              <consume-content v-if="type === 'render'" pageType="center"
                               :data="scope.row" :renderContent="renderContent" />
              <span v-if="type !== 'render' && type !== 'uploadMeetingPerson' && type !== 'fontStatus' && type !== 'personImg'" :title="scope.row[key]">{{scope.row[key] || '--'}}</span>
              <span v-if="type === 'personImg' && !scope.row[key]">--</span>
              <el-popover
                placement="top"
                width="160"
                trigger="hover"
                offset="60"
                v-if="type === 'personImg' && scope.row[key]">
                <a slot="reference" style="color: #1362FF">预览</a>
                <img :src="scope.row[key]" style="display: block;width: 120px;height: 160px; margin: 0 auto;">
              </el-popover>
              <span v-if="type === 'fontStatus'">
                <span v-if="scope.row[key] === '成功'" style="color: #3DF915">{{scope.row[key]}}</span>
                <span v-else style="color: #F63F34">{{scope.row[key]}}</span>
              </span>
            </template>
          </el-table-column>

          <el-table-column v-if="operations && operations.length > 0" label="操作"
                           :min-width="50">
            <template slot-scope="scope">
              <span v-for="operation in operations" class="operation" :key="operation.id">
                <a v-if="operation === 'detail'" @click="showCurrent(scope.row.code)">查看</a>
                <a v-else-if="operation === 'deletePlan'" :class="{ hideBox: (scope.row.id === 1) }"
                   @click="handleDelete(scope.row.code)">删除</a>
                <!--<a v-if="operation === 'modify'" @click="showModify(scope.row.id)">修改</a>-->
                <a v-else-if="operation === 'delete'"
                   @click="handleDelete(scope.row.code)">删除</a>
                <name-upload v-else-if="operation === 'upload-btn'" :cathUrl="uploadUrl" value="导入名单" style="display: inline-block;"/>

                <a v-else-if="operation.type === 'a'"
                   :href="operation.getHref(scope.row)"
                   target="_blank"
                >{{operation.text}}</a>

                <qr-popover-box v-else-if="operation.type === 'qr-pop-box'"
                                :title="operation.title" :text="operation.text"
                                :content="operation.getContent(scope.row)"
                />

                <consume-content
                  v-else-if="operation.renderContent"
                  :data="scope.row" :renderContent="operation.renderContent"
                  :vm="vm"
                />

                <a v-else class="hideBox">ERROR</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- endregion 表格 -->
        <!-- region 分页 -->
        <div class="page">
          <el-pagination background layout="total, prev, pager, next, jumper"
                         :current-page="+(requestBody.pageNum)"
                         @current-change="onPageChange" :total="total">
          </el-pagination>
        </div>

        <el-dialog
          id="personCurrentBox"
          :visible.sync="personCurrentImg"
          width="30%">
          <img :src="personCurrentImgUrl" style="display: block;margin: 0 auto; width: 90%;">
        </el-dialog>
      </div>
      <!-- endregion 分页 -->
    </div>

  </div>
</template>

<script>
import BreadCrumb from '../common/bread-crumb'
import OpBarItems from '../common/op-bar-items'
import diDingMixin from './di-ding-mixin'
import ConsumeContent from '../common/consume-content'
import {nSuccess, nTipFunc} from '../../../../utils/notice'
import QrPopoverBox from '../common/qr-popover-box'
import _flattenDeep from 'lodash/flattenDeep'
import {errorHandler} from '../../../../utils/errorHandler'
import QrCodeWithLogo from 'qr-code-with-logo'
import {api} from '../../../../view/api/access-ctrl'
import NameUpload from '../../buttons/name-upload'
import STree from '../../s-tree'
import Breadcrumb from '../../../Breadcrumb/Breadcrumb'
import DeviceTree from '../../../Tree/device-tree'
export default {
  components: {
    DeviceTree,
    Breadcrumb,
    STree,
    NameUpload,
    QrPopoverBox,
    BreadCrumb,
    OpBarItems,
    ConsumeContent
  },
  name: 'di-ding-center',
  mixins: [diDingMixin],
  computed: {
    subConfig () {
      return this.config.center
    },
    operations () {
      return this.subConfig.table.operations
    }
  },
  data () {
    return {
      loading: true,
      data: [],
      requestBody: {
        pageNum: '1',
        pageSize: '10',
        searchKey: '',
        deviceType: '',
        deviceUse: '',
        deviceStatus: ''
      },
      total: 0,
      dataInConfig: {},
      vm: this,
      uploadUrl: '',
      selectedTreeNode: '',
      filterText: '',
      selected: [],
      treeUpdate: {
        render: (code) => {
          return api.getAccessDeviceChildrenByCode(code)
            .then(list => {
              list.forEach(tree => {
                tree._label = tree.name
              })
              return list
            })
        }
      },
      treeUpdate1: {
        render: (code) => {
          return api.getAccessDeviceChildrenByCode(code)
            .then(list => {
              let arr = []
              list.map(v => {
                v._label = v.name
                if (!v.deviceType || (v.deviceType && (v.deviceType !=='3' && v.deviceType !== '4'))) {
                  arr.push(v)
                }
              })
              return arr
            })
        }
      },
      treeUpdate2: {
        render: (code) => {
          return api.getAccessDeviceChildrenByCode(code)
            .then(list => {
              let arr = []
              list.map(v => {
                v._label = v.name
                if (!v.deviceType || (v.deviceType && (v.deviceType ==='3' || v.deviceType === '4'))) {
                  arr.push(v)
                }
              })
              return arr
            })
        }
      },
      personCurrentImg: false,
      personCurrentImgUrl: '',
      personCurrentShow (url) {
        this.personCurrentImgUrl = url
        this.personCurrentImg = true
      }
    }
  },
  created () {
    this.render()
    // this.uploadUrl = api.uploadPayGayList()
  },
  watch: {
    $route: 'render'
  },
  methods: {
    handleSelected (code, deviceType) {
      this.requestBody.pageNum = '1'
      this.requestBody.deviceCode = code
      this.requestBody.deviceType = deviceType
      this.getData()
      // this.selectedTreeNode = $event
      // console.log($event.data.id)
      // this.requestBody.organizationId = $event.data.id
      // this.renderPosDevices()
    },
    renderPosDevices () {
      api.getAccessDevice(this.requestBody)
        .then(data => {
          // for (let k = 0; k < data.list.length; k++) {
          //   if (data.list[k].deviceStatus === '1') {
          //     data.list[k].deviceStatus = '在线'
          //   } else {
          //     data.list[k].deviceStatus = '离线'
          //   }
          // }
          this.total = data.total
          this.posDevices = data.list
        })
    },
    render () {
      this.initData()
      const {created} = this.subConfig // 并不推荐使用
      created && created.call(this)
      this.beforeDataIsGet()
        .then(this.getData)
    },
    initData () {
      this.requestBody = {
        pageNum: '1',
        pageSize: '10',
        searchKey: ''
      }
    },
    beforeDataIsGet () {
      const payload = this.getPayload()
      const beforeDataIsGetChainA = this.keyMappingEntities
        .filter(([, {beforeDataIsGet}]) => beforeDataIsGet)
        .map(([, {beforeDataIsGet}]) => beforeDataIsGet(payload))

      const beforeDataIsGetChainB = _flattenDeep(this.subConfig.opBar)
        .filter(it => it && it.beforeDataIsGet)
        .map(it => it && it.beforeDataIsGet && it.beforeDataIsGet(payload))

      return Promise.all([
        ...beforeDataIsGetChainA,
        ...beforeDataIsGetChainB
      ])
    },
    getData () {
      if (this.subConfig.searchTree) {
        if (this.subConfig.searchTree.searchType) {
          if (this.subConfig.searchTree.searchType === 'code') {
            this.requestBody.deviceUse = '2'
          } else if (this.subConfig.searchTree.searchType === 'face') {
            this.requestBody.deviceUse = '1'
          } else {
            this.requestBody.deviceUse = ''
          }
        }
      }
      this.loading = true
      this.config.get(this.requestBody)
        .then(this.onDataLoaded)
        .then(this.fetchDetail)
        .catch(errorHandler('请求错误'))
        .then(this.loaded)
    },
    onDataLoaded ({list, total}) {
      const {keyMappingEntities} = this
      list.forEach(it => {
        keyMappingEntities.forEach(([key, {onDataLoaded}]) => {
          // 配置中的 onDataLoaded
          onDataLoaded && onDataLoaded(it, 'center')
        })
        this.formHelper(it)
      })
      this.total = total
      this.data = list
    },
    fetchDetail () {
      const {data} = this
      this.keyMappingEntities.forEach(([, {fetchDetail, onDetailLoaded}]) => {
        fetchDetail && fetchDetail()
          .then(detailList => {
            data.forEach(it => {
              onDetailLoaded(it, detailList)
              this.formHelper(it)
            })
          })
      })
    },
    /**
     * 针对表单的特殊处理
     */
    formHelper (item) {
      this.keyMappingEntities.forEach(([key]) => {
        const spData = item[`_${key}`]
        if (spData) {
          item[key] = spData._label
        }
      })
    },
    search (entity) {
      this.requestBody = {
        ...this.requestBody,
        ...entity
      }
      this.requestBody.pageNum = '1'
      this.getData()
    },
    onPageChange (pageNum) {
      this.requestBody.pageNum = pageNum + ''
      this.getData()
    },
    showCurrent (id) {
      if (this.config.routerPush) {
        this.config.routerPush.current.call(this, id)
        return
      }
      this.routerPush('diDingCurrent', {
        diName: this.diName,
        id
      })
    },
    showModify (id) {
      if (this.config.routerPush) {
        this.config.routerPush.modify.call(this, id)
        return
      }
      this.routerPush('diDingModify', {
        diName: this.diName,
        id
      })
    },
    showQr (id, authUrl) {
      QrCodeWithLogo.toCanvas({
        canvas: document.getElementById(`receipt_account_canvas_${id}`),
        content: authUrl,
        width: 200
      }).catch(e => console.error(e))
    },
    handleSelectionChange (selectedIds) {
      this.selected = selectedIds
    },
    handleDelete (id) {
      let data
      if (this.$route.params.diName === 'pay-hall-unpaid-record') {
        data = {}
        data.ids = id.toString()
      } else {
        data = ''
        data = id.toString()
      }
      this.$confirm('确认删除？')
        .then(
          () =>
            this.config.delete(data)
              .then(nTipFunc('删除成功'))
              .then(this.render)
          ,
          () => {
            console.debug('用户取消了删除')
          }
        )
        .catch(errorHandler('请求失败'))
    }
  },
  onUploadSuccess (data) {
    const e = errorHandler('导入失败')(data)
    if (!(e instanceof Error)) {
      nSuccess('导入成功')
    }
  }
}
</script>

<style scoped lang="less">
  .line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:0 0 10px 0;
    padding: 0 10px;
    width: 100%;
  }
.line:nth-child(n+2){
   justify-content: flex-start;
   &>div:nth-child(n+2){
    margin-left: 12PX;
   }
}
  .operation {
    margin-left: 5px;
  }

  .operation a{
    color: #1362FF;
  }
  .operation a:hover{
    color: #06b3ff;
  }

  .hasMargin {
    margin: 20px 0;
  }

  .mr{
    margin-left: 1%;
  }
</style>

<style lang="less">
  @import "common";
  .school {
    width: 22%;
    padding-right: 10px;
  }
  .generate-common-style();

  .center {
    .op-bar {
      display: block!important;
      .block {
        width: 100%;
      }
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0;
    width: unset;
    color: #606266;
  }

  .di-ding-table-header {
    th {
      background-color: #EFF1F5 !important;
      color: #48576A;
      .cell {
        text-align: center;
      }
    }
  }

  .di-ding {
    .el-table__body-wrapper {
      overflow-x: hidden;
    }
  }

  .el-table__body {
    td {
      .cell {
        text-align: center;
        span, div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .block:last-child {
    display: block!important;
    overflow: hidden;
    .flex-align-center {
      float: left;
    }
    .flex-align-center:last-child {
      float: right;
    }
  }

  .page {
    //position: absolute;
    //bottom: 20px;
    //left: 0;
    //right: 0;
    .el-pagination {
      text-align: center;
    }
  }
  .w77{
    width: 77%;
  }
  .flexBox{
    display: flex;
  }
  .paddingTop {
    padding-top: 20px;
  }
  .borderRight{
    border-right: 1px solid #e6ebf2;
  }
  .hideBox{
    display: none;
  }
  .personImg .el-icon-zoom-in {
    font-size: 16px;
    z-index: 1;
    color: white;
    width: 24px;
    height: 32px;
    text-align: center;
    padding: 10px 0;
    display: none!important;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #999999;
    opacity: 0.6;
  }
  .personImg {
    display: inline-block;
    width: 24px;
    height: 32px;
    margin-left: 10px;
    position: relative;
  }
  .personImg:hover .el-icon-zoom-in {
    display: inline-block!important;
    cursor: pointer;
  }
  #personCurrentBox {
    .el-dialog__header {
      border: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/pages/center.vue